module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showForm),
      expression: "showForm"
    }],
    staticClass: "form collapsed",
    class: {
      deployed: _vm.active
    }
  }, [(!_vm.$root.isMobile || _vm.showCloseMobile) ? _c('a', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }) : _c('a', {
    staticClass: "open",
    class: {
      close: _vm.active
    },
    on: {
      "click": _vm.sub
    }
  }), _vm._v(" "), _c('form', {
    class: {
      hidden_form: _vm.shows
    },
    attrs: {
      "action": "",
      "method": "POST",
      "novalidate": "true"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.check($event)
      }
    }
  }, [_c('span', {
    staticClass: "desc",
    on: {
      "click": _vm.sub
    }
  }, [_vm._v("\n                    Оставьте свой e-mail и получите скидку 15% на первый заказ в интернет-магазине "), _c('a', {
    attrs: {
      "href": "https://www.weleda.ru/",
      "target": "_blank"
    }
  }, [_vm._v("www.weleda.ru")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Ваш e-mail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formErrors.length) ? _c('p', _vm._l((_vm.formErrors), function(error) {
    return _c('span', {
      staticClass: "err"
    }, [_vm._v(_vm._s(error))])
  })) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Получить")])]), _vm._v(" "), _c('p', {
    staticClass: "inform"
  }, [_c('a', {
    attrs: {
      "href": "/static/pdf/Personal-information.pdf",
      "download": "Personal information"
    }
  }, [_vm._v("Условия и способы обработки и хранения персональных данных")])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shows),
      expression: "shows"
    }],
    staticClass: "code"
  }, [_c('p', [_vm._v("Ваш промокод: LEMON")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.weleda.ru/",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('product', 'click', 'linkpopup')
      }
    }
  }, [_vm._v("www.weleda.ru")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e11123c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Form.vue
// module id = 545
// module chunks = 1